module.exports = __webpack_public_path__ + "img/BannerPatHome1.bd93f9f7.webp";